import React from "react";

import {
  AdminTodoResponse,
  BackfillQueueResponse,
  SchedulerStatusResponse,
  SnapshotQueueResponse,
} from "../../../../../services";
import { SECTION_LABELS } from "../../constants";
import { HealthGrid } from "../../styles";
import {
  pendingWorkCount,
  schedulersSummary,
  snapshotHealthStatus,
} from "../../utils/health";
import {
  labelOfStatus,
  problemsFirst,
  toneOfStatus,
} from "../../../utils/status";
import { HealthCell } from "./HealthCell";
import { HealthStripProps, HealthSummary } from "./types";

const summariseSnapshots = (queue: SnapshotQueueResponse): HealthSummary => {
  const status = snapshotHealthStatus(queue);
  return { tone: toneOfStatus(status), label: labelOfStatus(status) };
};

const summariseBackfills = ({
  status,
}: BackfillQueueResponse): HealthSummary => ({
  tone: toneOfStatus(status),
  label: labelOfStatus(status),
});

const summariseSchedulers = (
  schedulers: SchedulerStatusResponse[],
): HealthSummary => {
  const [worst] = problemsFirst(schedulers);
  return {
    tone: worst ? toneOfStatus(worst.status) : "unknown",
    label: schedulersSummary(schedulers),
  };
};

const summarisePendingWork = (todo: AdminTodoResponse): HealthSummary => {
  const count = pendingWorkCount(todo);
  return count > 0
    ? { tone: "unknown", label: `${count} to review` }
    : { tone: "healthy", label: "None" };
};

export const HealthStrip: React.FC<HealthStripProps> = ({ sections }) => (
  <HealthGrid aria-label="Operational status">
    <HealthCell
      label={SECTION_LABELS.snapshotQueue}
      section={sections.snapshotQueue}
      summarise={summariseSnapshots}
    />
    <HealthCell
      label={SECTION_LABELS.backfillQueue}
      section={sections.backfillQueue}
      summarise={summariseBackfills}
    />
    <HealthCell
      label={SECTION_LABELS.schedulers}
      section={sections.schedulers}
      summarise={summariseSchedulers}
    />
    <HealthCell
      label={SECTION_LABELS.todo}
      section={sections.todo}
      summarise={summarisePendingWork}
    />
  </HealthGrid>
);
